<template>
    <video
        :autoplay="config.video.autoplay ?? undefined"
        :controls="config.video.controls ?? undefined"
        :loop="config.video.loop ?? undefined"
        :muted="config.video.muted ?? undefined"
        :poster="config.video.poster ?? undefined"
        :height="config.video.height ?? undefined"
        :width="config.video.width ?? undefined"
    >
        <source
            v-for="(source, index) in config.source"
            :key="`block-inline-video-source-${index}`"
            :src="source.src"
            :type="source.type"
        />
    </video>
</template>

<script lang="ts" setup>
    import type {
        ContentBlockInlineVideo,
        ContentBlocksComponentProps
    } from '~/types';

    withDefaults(
        defineProps<ContentBlocksComponentProps<ContentBlockInlineVideo>>(),
        {
            theme: 'light',
            breakpoint: 'desktop',
            breakpointName: 'md'
        }
    );
</script>

<style lang="scss"></style>
